var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","color":"primary accent-4","dense":"","dark":""}},[_c('v-toolbar-title',[_c('v-icon',[_vm._v("mdi-door-closed-lock")]),_vm._v(" Door Opener ")],1),_c('v-spacer')],1),_c('v-main',[_c('DoorOpener')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }